<!--固件列表-->
<template>
  <div class="firmware-list">
    <div class="header">
      <el-button
        :disabled="rolesCode === 'SALE'"
        type="primary"
        size="14"
        @click="handleAssociatedFirmware">关联固件</el-button>
      <el-button
        :disabled="rolesCode === 'SALE'"
        type="add"
        size="14"
        icon="el-icon-plus"
        @click="handleAddFirmware">新建固件</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#F5F6F7' }"
      size="medium">
      <el-table-column prop="key" label="固件Key"> </el-table-column>
      <el-table-column prop="name" label="固件名称"> </el-table-column>
      <el-table-column prop="type" label="固件类型"> </el-table-column>
      <el-table-column prop="version" label="固件版本"> </el-table-column>
      <el-table-column prop="number" label="自定义编号"> </el-table-column>
      <el-table-column prop="description" label="版本说明"> </el-table-column>
      <el-table-column prop="fileName" label="文件名称"> </el-table-column>
      <el-table-column prop="fileName" label="发布状态">
        <template slot-scope="scope">
          <span v-if="scope.row.releaseStatus === 0">未发布</span>
          <span v-else>已发布</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="450">
        <template slot-scope="scope">
          <el-button type="text" :disabled="rolesCode === 'SALE'" size="operate" @click="handleChangeVersion(scope.row)">变更版本</el-button>
          <el-button type="text" size="operate" @click="jumpDetails(scope.row)">详情</el-button>
          <el-button type="text" :disabled="rolesCode === 'SALE'" size="operate" @click="handleDetails(scope.row)">发布</el-button>
          <el-button type="text" :disabled="rolesCode === 'SALE'" size="operate" @click="handleDetails(scope.row)">测试任务</el-button>
          <el-button type="text" :disabled="rolesCode === 'SALE'" size="operate" @click="handleDetails(scope.row)">升级任务</el-button>
          <el-button type="text" :disabled="rolesCode === 'SALE'" size="operate" @click="handleDetails(scope.row)">解除绑定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <addFirmwareDialog
      ref="addFirmware"
      @close="handleClose"
      @submit="submitForm('form')" />
    <associatedFirmwareDialog
      ref="associatedFirmware"
      :product-id="productId"
      :product-name="form.productName"
      @close="handleClose" />
    <changeVersionDialog
      ref="changeVersion"
      @close="handleClose"
      @submit="submitForm('form')" />
  </div>
</template>
<script>
import { getFirmwareList, addFirmware, deleteFirmwareInfo, firmwareOnline, updateFirmwareReleaseStatus } from "@/api/product/product-details"
import store from '@/store'
import { mapGetters } from 'vuex'
import addFirmwareDialog from './firmware/addFirmwareDialog.vue'
import associatedFirmwareDialog from './firmware/associatedFirmwareDialog.vue'
import changeVersionDialog from './firmware/changeVersionDialog.vue'
export default {
  name: "firmware",
  components: { addFirmwareDialog, associatedFirmwareDialog, changeVersionDialog },
  data() {
    const validatePackage = (rule, value, callback) => {
      if (this.fileList.length === 0) {
        callback(new Error('请上传固件'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      tableData: [], // 表格数据
      dialogVisible: false,
      form: {
        name: "", // 固件名称
        productId: '', // 产品id
        productName: '' // 产品名字
      },
      productId: "", // 当前产品id
      stateList: [
        // 状态
        { value: 0, label: "开发中" },
        { value: 1, label: "已上线" }
      ],
      current: 1, // 当前页面
      size: 10, // 一页展示多少条
      total: 0, // 总条数
      fileList: [], // 上传的固件文件
      uploadSuccessOrError: false, // 上传固件成功则展示固件基本信息否则不展示
      firmwarePackage: "", // 上传成功的固件包信息
      uploadLoading: '', // 上传固件弹窗的loading
      uploadPercentage: 0, // 上传进度百分比
      isUploading: false, // 是否正在上传
      headerObj: {
        'TENANT-ID': store.getters.userInfo.tenantId,
        Authorization: 'Bearer ' + store.getters.access_token
      }
    }
  },
  computed: {
    ...mapGetters(['rolesCode'])
  },
  created() { },
  mounted() {
    this.productId = this.$route.query.productId
    this.form.productName = this.$route.query.productName
    this.getFirmwareListFun()
  },
  methods: {
    // 固件名称校验
    validateName(rule, value, callback) {
      const flag = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5]+$/).test(value)
      if (!flag) {
        callback(new Error('请输入规范的固件名称'))
      } else {
        callback()
      }
    },
    // 超时时长校验
    validateTimeoutTime(rule, value, callback) {
      const flag = new RegExp(/^(?:1[01]?[0-9]|120|[1-9][0-9]?)$/).test(value)
      if (!flag) {
        callback(new Error('请输入规范的超时时长'))
      } else {
        callback()
      }
    },
    // 固件上线
    firmwareOnlineFun(row) {
      var params = {
        firmwareId: row.id
      }
      firmwareOnline(params).then((res) => {
        this.getFirmwareListFun()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 字节单位转换为m
    bytesToMegabytes(bytes) {
      const megabytes = parseInt(bytes) / (1024 * 1024)
      return megabytes.toFixed(4) + 'M'
    },
    // 固件列表
    getFirmwareListFun() {
      this.loading = true
      var params = {
        productId: this.productId,
        size: this.size,
        current: this.current
      }
      getFirmwareList(params).then((res) => {
        // this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    // 关联固件
    handleAssociatedFirmware() {
      this.$refs.associatedFirmware.associatedDialogVisible = true
    },
    // 新建固件
    handleAddFirmware() {
      this.$refs.addFirmware.dialogVisible = true
    },
    // 变更版本
    handleChangeVersion() {
      this.$refs.changeVersion.changeVersionDialogVisible = true
    },
    // 跳转详情
    jumpDetails(row, index) {
      // 在跳转到详情页面之前保存当前的 tab
      localStorage.setItem('current', 4)
      this.$router.push({
        path: "/product/product-details/firmware/firmwareDetails/firmwareDetails",
        query: {
          firmwareId: row.id,
          version: row.version,
          productName: this.form.productName,
          state: row.state,
          index: index //区分跳转之后展示测试任务or升级任务
        }
      })
    },
    // 下载
    downloadReport(url, fileName) {
      this.downBlobFile(url, {}, fileName)
    },
    // 更新固件发布状态
    handleRelease(row) {
      var params = {
        firmwareId: row.id,
        releaseStatus: row.releaseStatus === 0 ? 1 : 0 // 如果是未发布则发布，已发布则取消发布
      }
      updateFirmwareReleaseStatus(params).then((res) => {
        this.getFirmwareListFun()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 新建固件弹窗关闭
    handleClose() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
      this.fileList = []
      this.uploadSuccessOrError = false
    },
    // 只能上传一个固件，超过替换
    handleChange(file, fileList) {
      // this.fileList = [file];
    },
    // 固件上传失败
    uploadError(err, file, fileList) {
      this.isUploading = false
      this.uploadPercentage = 0
      this.$message.error(err)
    },
    // 固件上传成功
    uploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.fileList = [file]
        this.uploadSuccessOrError = true
        this.firmwarePackage = response.data
        this.isUploading = false
        this.uploadPercentage = 0
      } else {
        this.$message.error(response.msg)
        this.isUploading = false
        this.uploadPercentage = 0
      }
      // 关闭loading
      this.uploadLoading = false
    },
    // 固件包上传时的钩子
    uploadProgress(event, file, fileList) {
      this.isUploading = true
      this.uploadPercentage = Math.floor(event.percent)
      // 开启loading
      // this.uploadLoading = true
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.size = val
      this.getFirmwareListFun()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.current = val
      // this.submitForm('form')
      this.getFirmwareListFun()
    },
    // 状态格式化
    statusFormatter(val) {
      const label = this.stateList.find((option) => option.value === val.state).label || "-"
      return label
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addFirmwareFun()
        } else {
          return false
        }
      })
    },
    // 上传固件 以及固件信息
    addFirmwareFun() {
      this.uploadLoading = true
      this.firmwarePackage.name = this.form.name
      var params = Object.assign({}, this.form, this.firmwarePackage)
      addFirmware(params).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.$message.success('上传成功')
        this.handleClose()
        this.getFirmwareListFun()
        this.uploadLoading = false
      }).catch(err => {
        this.uploadLoading = false
        this.$message.error(err.message)
      })
    },
    // 删除固件
    deleteFirmwareInfoFun(row) {
      const params = {
        firmwareId: row.id
      }
      this.$confirm('固件删除后不可恢复，请谨慎操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteFirmwareInfo(params).then((res) => {
          this.getFirmwareListFun()
        }).catch(err => {
          this.$message.error(err.message)
        })
      }).catch(err => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  // display: flex;
  // justify-content: space-between;
  // align-items: left;
  float: right;
  margin-bottom: 15px;
}

::v-deep .upload-demo {
  .el-upload {
    width: 100%;
  }

  .el-button {
    width: 100%;
    color: #275fe8;
    font-size: 14px;
  }
}

.el-upload__tip {
  float: right;
  margin: 0px;
  line-height: 20px;
  color: #808080;
}

.uploadInfo {
  text-align: left;
  background: #f7f7f9;
  padding-left: 10px;
  margin: 4px 0 0 -100px;

  .el-row {
    padding-left: 10px;

    .el-col {
      margin: 0px;
    }
  }

  .infoTitle {
    font-size: 14px;
    color: #808080;
  }

  .infoVal {
    color: #252525;
  }
}

::v-deep .el-textarea .el-input__count {
  background: transparent;
  right: 20px;
  bottom: 0;
}

::v-deep .el-upload-list {
  display: none;
}

::v-deep .el-dialog__body {
  padding: 40px 58px 36px 50px;
}

::v-deep .el-form-item__label {
  color: #808080;
}

::v-deep .firmwareName .el-input__inner {
  color: #275fe8;
}

::v-deep .el-input-group__append {
  background-color: #ffffff;
  color: #808080;
}

::v-deep .el-button+.el-button {
  margin-left: 16px;
}

::v-deep .name-input .el-input__inner {
  padding-left: 15px;
  padding-right: 48px;
  background: transparent;
}

::v-deep .el-table__fixed-right-patch {
  background-color: #F5F6F7;
}
</style>
